/* ZEPHIR · ficha editorial (2026-10-21). Ver sections/zephir-pdp.liquid.
   - Color y talla, fotos del color, precio, boton y URL (?variant=).
   - El boton agrega con el boton rapido del tema ([data-action-atc] + data-variant-id):
     el tema agrega y abre el cajon; aqui solo se mantienen esos atributos al dia.
   - "Comprar ahora": agrega por /cart/add.js y va a /checkout.
   - Retiro en tienda: ?section_id=pickup-availability por variante.
   - Movil: puntos del carrusel y barra de compra fija.
   - Recomendados ("Podria gustarte"): carga diferida y "+" con tallas. */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function plata(cent) { return '$' + Math.round(cent / 100).toLocaleString('es-CO'); }
  function norm(t) {
    t = String(t || '').trim().toUpperCase();
    if (t === 'XX') return 'XXL';
    if (t === 'U' || t === 'ÚNICA' || t === 'TALLA ÚNICA' || t === 'TALLA UNICA') return 'UNICA';
    return t;
  }

  function iniciarFicha(raiz) {
    if (raiz.dataset.zpdpListo) return;
    raiz.dataset.zpdpListo = '1';
    var datosEl = $('[data-zpdp-json]');
    if (!datosEl) return;
    var D;
    try { D = JSON.parse(datosEl.textContent); } catch (e) { return; }

    var st = { color: D.colorIni || null, talla: D.tallaIni || null };
    var ci = D.colorIdx, si = D.sizeIdx;
    var otros = (D.selIni || []).slice();   /* opciones que no son color ni talla (p. ej. Tipo, Precio) */
    function coinciden(v, salvo) {
      for (var k = 0; k < v.o.length; k++) {
        if (k === ci || k === si || k === salvo) continue;
        if (otros[k] != null && v.o[k] !== otros[k]) return false;
      }
      return true;
    }
    var barra = $('[data-zpdp-bar]');
    var urlProducto = raiz.getAttribute('data-product-url') || D.url;

    function variante(color, talla) {
      return D.variantes.filter(function (v) {
        if (ci > -1 && v.o[ci] !== color) return false;
        if (si > -1 && v.o[si] !== talla) return false;
        return coinciden(v);
      })[0] || null;
    }
    function primeraDelColor(color) {
      var vs = D.variantes.filter(function (v) { return (ci < 0 || v.o[ci] === color) && coinciden(v); });
      return vs.filter(function (v) { return v.a; })[0] || vs[0] || null;
    }
    function tallaDisponible(color, talla) {
      return D.variantes.some(function (v) { return (ci < 0 || v.o[ci] === color) && v.o[si] === talla && v.a && coinciden(v); });
    }
    function actual() {
      if (D.soloUna) return D.variantes[0];
      if (si > -1 && !st.talla) return null;
      return variante(st.color, st.talla);
    }

    /* ---- fotos ---- */
    var track = $('[data-zpdp-track]', raiz), media = $('[data-zpdp-scroll]', raiz), dots = $('[data-zpdp-dots]', raiz), tira = $('[data-zpdp-thumbs]', raiz);
    function esEscritorio() { return window.matchMedia('(min-width: 1024px)').matches; }
    /* Tira de miniaturas sobre la galeria (escritorio), como en Scuffers: una por foto, en el mismo
       orden; la activa resaltada; clic = ir a esa foto. */
    function pintarTira() {
      if (!tira || !track) return;
      var slides = $$('[data-zpdp-slide]', track);
      if (slides.length < 2) { tira.innerHTML = ''; return; }
      tira.innerHTML = slides.map(function (sl, k) {
        var im = sl.querySelector('img'), src = im ? (im.getAttribute('src') || '') : '';
        src = src.replace(/([?&])width=\d+/, '$1width=160');
        return '<button type="button" class="zpdp__thumb" data-k="' + k + '" aria-label="Ver foto ' + (k + 1) + '">' + (src ? '<img src="' + src + '" alt="" loading="lazy" width="60" height="84">' : '') + '</button>';
      }).join('');
      marcarTira();
    }
    function marcarTira() {
      if (!tira || !media || !esEscritorio()) return;
      var slides = $$('[data-zpdp-slide]', track), top = media.scrollTop + media.clientHeight * 0.35, act = 0;
      slides.forEach(function (sl, k) { if (sl.offsetTop <= top) act = k; });
      $$('.zpdp__thumb', tira).forEach(function (t, k) {
        var on = k === act; t.classList.toggle('is-active', on); t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) { var tt = tira.scrollTop, tb = tt + tira.clientHeight; if (t.offsetTop < tt || t.offsetTop + t.offsetHeight > tb) tira.scrollTop = t.offsetTop - tira.clientHeight / 2 + t.offsetHeight / 2; }
      });
    }
    if (tira) tira.addEventListener('click', function (e) {
      var t = e.target.closest('.zpdp__thumb'); if (!t || !media) return;
      var sl = $$('[data-zpdp-slide]', track)[+t.getAttribute('data-k')];
      if (sl) media.scrollTo({ top: sl.offsetTop, behavior: 'smooth' });
    });
    if (media) media.addEventListener('scroll', function () { window.requestAnimationFrame(marcarTira); }, { passive: true });
    function handle(s) { return String(s || '').toLowerCase().trim().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
    function pintarFotos() {
      /* Todas las fotos quedan visibles; las del color elegido pasan al principio (orden original
         dentro de cada grupo: color elegido, generales, demas colores). */
      if (ci < 0 || !track) return;
      var h = handle(st.color), slides = $$('[data-zpdp-slide]', track);
      function pos(sl) { return +(sl.getAttribute('data-i') || 0); }
      var grupo = function (sl) { var c = sl.getAttribute('data-color'); return c === h ? 0 : (c === '' ? 1 : 2); };
      slides.sort(function (x, y) { return grupo(x) - grupo(y) || pos(x) - pos(y); });
      slides.forEach(function (sl) { track.appendChild(sl); });
      slides.slice(0, 2).forEach(function (sl) { var im = sl.querySelector('img'); if (im) im.loading = 'eager'; });
      track.scrollLeft = 0;
      if (media && esEscritorio()) media.scrollTop = 0;
      pintarPuntos(); pintarTira();
    }
    function pintarPuntos() {
      if (!dots || !track) return;
      var n = $$('[data-zpdp-slide]', track).length;
      dots.classList.toggle('is-barra', n > 10);
      if (n < 2) { dots.innerHTML = ''; return; }
      dots.innerHTML = n > 10 ? '<span class="zpdp__dot is-active" style="width:' + (100 / n) + '%"></span>' : new Array(n + 1).join('<span class="zpdp__dot"></span>');
      marcarPunto();
    }
    function marcarPunto() {
      if (!dots || !track) return;
      var sl = $('[data-zpdp-slide]', track), w = (sl && sl.clientWidth) || track.clientWidth || 1;
      var n = $$('[data-zpdp-slide]', track).length, i = Math.round(track.scrollLeft / w);
      if (dots.classList.contains('is-barra')) { var d = $('.zpdp__dot', dots); if (d) d.style.transform = 'translateX(' + (i * 100) + '%)'; return; }
      $$('.zpdp__dot', dots).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(marcarPunto); }, { passive: true });

    /* ---- precio, tallas, boton ---- */
    function pintarPrecio(v) {
      v = v || primeraDelColor(st.color) || D.variantes[0];
      if (!v) return;
      var html = (v.c > v.p ? '<del>' + plata(v.c) + '</del> ' : '') + '<span>' + plata(v.p) + '</span>';
      $$('[data-zpdp-precio]').forEach(function (el) { el.innerHTML = html; });
      var bp = $('[data-zpdp-bar-precio]'); if (bp) bp.textContent = plata(v.p);
    }
    function pintarTallas() {
      $$('[data-zpdp-talla]', raiz).forEach(function (b) {
        var t = b.getAttribute('data-zpdp-talla'), ok = tallaDisponible(st.color, t), sel = t === st.talla;
        b.classList.toggle('is-agotada', !ok);
        if (ok) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
        b.classList.toggle('is-active', sel);
        b.setAttribute('aria-checked', sel ? 'true' : 'false');
      });
      var nom = $('[data-zpdp-talla-nombre]', raiz); if (nom) nom.textContent = st.talla ? st.talla.replace('UNICA', 'Única') : '';
      var bt = $('[data-zpdp-bar-talla]');
      if (bt) {
        $$('option', bt).forEach(function (o) { if (o.value) { var ok = tallaDisponible(st.color, o.value); o.disabled = !ok; o.textContent = o.value.replace('UNICA', 'Única') + (ok ? '' : ' · agotada'); } });
        bt.value = st.talla || '';
      }
    }
    function pintarOtros() {
      $$('[data-zpdp-otro]', raiz).forEach(function (b) {
        var k = +b.getAttribute('data-zpdp-otro'), val = b.getAttribute('data-valor'), sel = otros[k] === val;
        var ok = D.variantes.some(function (v) { return v.a && v.o[k] === val && (ci < 0 || v.o[ci] === st.color) && coinciden(v, k); });
        b.classList.toggle('is-active', sel); b.setAttribute('aria-checked', sel ? 'true' : 'false');
        b.classList.toggle('is-agotada', !ok);
        var nom = $('[data-zpdp-otro-nombre="' + k + '"]', raiz); if (nom && sel) nom.textContent = val;
      });
    }
    function pintarColores() {
      $$('[data-zpdp-color]', raiz).forEach(function (b) {
        var sel = b.getAttribute('data-zpdp-color') === st.color;
        b.classList.toggle('is-active', sel);
        b.setAttribute('aria-checked', sel ? 'true' : 'false');
        if (sel) { var n = $('[data-zpdp-color-nombre]', raiz); if (n) n.textContent = b.getAttribute('data-nombre'); }
      });
      var bc = $('[data-zpdp-bar-color]'); if (bc) bc.value = st.color;
    }
    function pintarBoton() {
      var v = actual(), sinTalla = si > -1 && !st.talla && !D.soloUna;
      var txt = sinTalla ? 'Selecciona una talla' : (v && v.a ? 'Agregar al carrito' : 'Agotado');
      $$('[data-zpdp-atc]').forEach(function (b) {
        var t = b.querySelector('[data-zpdp-atc-txt]'); if (t) t.textContent = txt;
        var pr = b.querySelector('[data-zpdp-btn-precio]'); if (pr) pr.textContent = v && v.a ? plata(v.p) : '';
        b.classList.toggle('is-sin-talla', sinTalla);
        if (v && v.a) { b.setAttribute('data-action-atc', ''); b.setAttribute('data-variant-id', v.id); b.disabled = false; }
        else { b.removeAttribute('data-action-atc'); b.removeAttribute('data-variant-id'); b.disabled = !sinTalla; }
      });
      var stock = $('[data-zpdp-stock]', raiz);
      if (stock) {
        var hay = sinTalla ? D.variantes.some(function (x) { return x.a && (ci < 0 || x.o[ci] === st.color) && coinciden(x); }) : (v && v.a);
        stock.innerHTML = hay ? '<i></i><span>Disponible</span>' : '<i class="is-off"></i><span>Agotado en esta talla</span>';
      }
      var ahora = $('[data-zpdp-ahora]', raiz); if (ahora) ahora.disabled = !!(v && !v.a);
    }
    function pintarUrl() {
      var v = actual();
      if (!v || !window.history || !history.replaceState) return;
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.toString());
    }
    var tRetiro = null, ultimoRetiro = null;
    function pintarRetiro() {
      var caja = $('[data-zpdp-retiro]', raiz);
      if (!caja) return;
      var v = actual() || primeraDelColor(st.color);
      if (!v || v.id === ultimoRetiro) return;
      ultimoRetiro = v.id;
      clearTimeout(tRetiro);
      tRetiro = setTimeout(function () {
        var respaldo = setTimeout(function () { caja.innerHTML = '<p>Consulta la disponibilidad por tienda. <a href="/pages/encuentranos">Ver tiendas</a></p>'; }, 4500);
        fetch(urlProducto + '?variant=' + v.id + '&section_id=pickup-availability', { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            clearTimeout(respaldo);
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var c = doc.querySelector('.t4s-pickup-availability-container');
            if (c && c.textContent.trim()) caja.innerHTML = c.innerHTML;
            else caja.innerHTML = '<p>Consulta la disponibilidad por tienda. <a href="/pages/encuentranos">Ver tiendas</a></p>';
          })
          .catch(function () { clearTimeout(respaldo); caja.innerHTML = '<p>Consulta la disponibilidad por tienda. <a href="/pages/encuentranos">Ver tiendas</a></p>'; });
      }, 150);
    }
    function todo(conFotos) {
      pintarColores(); pintarOtros(); pintarTallas(); pintarPrecio(actual()); pintarBoton(); pintarUrl(); pintarRetiro();
      if (conFotos) pintarFotos();
      var av = $('[data-zpdp-aviso]', raiz); if (av && st.talla) av.textContent = '';
    }

    function elegirColor(c) {
      if (!c || c === st.color) return;
      st.color = c;
      if (st.talla && !tallaDisponible(c, st.talla)) st.talla = null;
      todo(true);
    }
    function elegirTalla(t) {
      if (!t) { st.talla = null; todo(false); return; }
      if (!tallaDisponible(st.color, t)) return;
      st.talla = t;
      todo(false);
    }

    raiz.addEventListener('click', function (e) {
      var c = e.target.closest('[data-zpdp-color]');
      if (c) { elegirColor(c.getAttribute('data-zpdp-color')); return; }
      var ot = e.target.closest('[data-zpdp-otro]');
      if (ot) {
        otros[+ot.getAttribute('data-zpdp-otro')] = ot.getAttribute('data-valor');
        if (st.talla && !tallaDisponible(st.color, st.talla)) st.talla = null;
        todo(false); return;
      }
      var t = e.target.closest('[data-zpdp-talla]');
      if (t && !raiz.contains(e.target.closest('#sizeGuideModal'))) {
        if (t.getAttribute('aria-disabled') === 'true') return;
        elegirTalla(t.getAttribute('data-zpdp-talla'));
      }
    });
    /* Teclado: flechas dentro de los grupos de color y talla. */
    raiz.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
      var grupo = e.target.closest('[role=radiogroup]'); if (!grupo) return;
      var bs = $$('[role=radio]', grupo).filter(function (b) { return b.getAttribute('aria-disabled') !== 'true'; });
      var i = bs.indexOf(e.target); if (i < 0) return;
      e.preventDefault();
      var j = (i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + bs.length) % bs.length;
      bs[j].focus(); bs[j].click();
    });

    /* Boton sin talla: avisar y marcar las tallas (el tema no actua porque no tiene data-action-atc). */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-zpdp-atc]');
      if (!b || b.hasAttribute('data-action-atc')) return;
      if (si > -1 && !st.talla) {
        e.preventDefault();
        var tallas = $('[data-zpdp-tallas]', raiz), av = $('[data-zpdp-aviso]', raiz);
        if (av) av.textContent = 'Elige tu talla para agregarla al carrito.';
        if (tallas) {
          tallas.classList.remove('is-flash'); void tallas.offsetWidth; tallas.classList.add('is-flash');
          if (b.closest('[data-zpdp-bar]') || tallas.getBoundingClientRect().top < 0) tallas.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, true);
    /* Mientras el tema agrega, el boton queda en espera. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-zpdp-atc][data-action-atc]');
      if (!b) return;
      b.classList.add('is-cargando');
      setTimeout(function () { b.classList.remove('is-cargando'); }, 1600);
    });

    var ahora = $('[data-zpdp-ahora]', raiz);
    if (ahora) ahora.addEventListener('click', function () {
      var v = actual();
      if (!v) { var b = $('[data-zpdp-atc]', raiz); if (b) b.click(); return; }
      if (!v.a) return;
      ahora.classList.add('is-cargando');
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { ahora.classList.remove('is-cargando'); var av = $('[data-zpdp-aviso]', raiz); if (av) av.textContent = 'No pudimos agregar la prenda. Inténtalo de nuevo.'; });
    });

    /* Retiro en tienda: abrir y cerrar la ventana de otras tiendas. */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-pickup-availability-popup-open]')) {
        e.preventDefault();
        var pop = $('.zpdp-retiro .t4s-pickup-availability-popup'); if (pop) pop.classList.add('is--open');
      }
      if (e.target.closest('[data-pickup-close]') || (e.target.classList && e.target.classList.contains('t4s-pickup-availability-popup'))) {
        var abierta = $('.t4s-pickup-availability-popup.is--open'); if (abierta) abierta.classList.remove('is--open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var abierta = $('.t4s-pickup-availability-popup.is--open'); if (abierta) abierta.classList.remove('is--open'); }
    });

    /* ---- barra fija (movil) ---- */
    if (barra) {
      var bc = $('[data-zpdp-bar-color]', barra), bt = $('[data-zpdp-bar-talla]', barra);
      if (bc) bc.addEventListener('change', function () { elegirColor(bc.value); });
      if (bt) bt.addEventListener('change', function () { elegirTalla(bt.value); });
      /* Se revisa en cada scroll (no con IntersectionObserver: si la pagina salta de una vez
         por encima de los botones, p. ej. con el enlace a las resenas, el observador no avisa). */
      var compra = $('[data-zpdp-buy]', raiz), pend = false, estado = null;
      function revisarBarra() {
        pend = false;
        if (!compra) return;
        var movil = !window.matchMedia('(min-width: 1024px)').matches;
        var mostrar = movil && compra.getBoundingClientRect().bottom < 0;
        if (mostrar === estado) return;
        estado = mostrar;
        barra.hidden = false;
        barra.classList.toggle('is-on', mostrar);
        document.body.classList.toggle('zpdp-bar-on', mostrar);
      }
      function pedirRevision() { if (!pend) { pend = true; window.requestAnimationFrame(revisarBarra); } }
      window.addEventListener('scroll', pedirRevision, { passive: true });
      window.addEventListener('resize', pedirRevision);
      revisarBarra();
    }

    /* Altura real de la cabecera fija (escritorio). */
    function cabecera() {
      var h = document.querySelector('#shopify-section-header-inline, .t4s-section-header');
      if (h) raiz.style.setProperty('--zpdp-head', Math.round(h.getBoundingClientRect().height) + 'px');
    }
    cabecera();
    window.addEventListener('resize', cabecera);

    todo(false);
    pintarPuntos();
    pintarTira();
    window.addEventListener('resize', function () { window.requestAnimationFrame(marcarTira); });
  }

  /* ---------- recomendados ---------- */
  function iniciarRecos(sec) {
    if (sec.dataset.zpdpListo) return;
    sec.dataset.zpdpListo = '1';
    function activar() {
      var track = $('.zpdp-recos__track', sec), barra = $('.zpdp-recos__barra span', sec);
      if (!track) { sec.classList.add('is-vacio'); return; }
      function mover() {
        if (!barra) return;
        var vis = track.clientWidth / track.scrollWidth, max = track.scrollWidth - track.clientWidth;
        barra.style.width = Math.max(vis * 100, 12) + '%';
        var frac = max > 0 ? track.scrollLeft / max : 0;
        barra.style.transform = 'translateX(' + (frac * (1 / Math.max(vis, 0.12) - 1) * 100) + '%)';
        barra.parentNode.style.visibility = max > 4 ? 'visible' : 'hidden';
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mover); }, { passive: true });
      window.addEventListener('resize', mover);
      mover();
      sec.addEventListener('click', function (e) {
        var mas = e.target.closest('[data-zpdp-mas]');
        if (mas) { e.preventDefault(); var card = mas.closest('.zpdp-card'); $$('.zpdp-card.is-abierta', sec).forEach(function (c) { if (c !== card) c.classList.remove('is-abierta'); }); card.classList.toggle('is-abierta'); return; }
        var cerrar = e.target.closest('[data-zpdp-cerrar]');
        if (cerrar) { e.preventDefault(); cerrar.closest('.zpdp-card').classList.remove('is-abierta'); return; }
        var talla = e.target.closest('.zpdp-card__talla[data-action-atc]');
        if (talla) { var c = talla.closest('.zpdp-card'); setTimeout(function () { c.classList.remove('is-abierta'); }, 400); }
      });
    }
    if ($('.zpdp-recos__track', sec)) { activar(); return; }
    var url = sec.getAttribute('data-url');
    if (!url) return;
    function cargar() {
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevo = doc.querySelector('[data-zpdp-recos]');
          if (nuevo && nuevo.querySelector('.zpdp-recos__track')) { sec.innerHTML = nuevo.innerHTML; activar(); }
          else sec.classList.add('is-vacio');
        })
        .catch(function () { sec.classList.add('is-vacio'); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); cargar(); } }, { rootMargin: '600px 0px' });
      io.observe(sec);
    } else cargar();
  }

  function arrancar() {
    $$('[data-zpdp]').forEach(iniciarFicha);
    $$('[data-zpdp-recos]').forEach(iniciarRecos);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
